module.exports = __webpack_public_path__ + "img/Ghostbuters - Answer The Call Bingo.7768494d.jpeg";